//合同路由
export default [{
  name: "votList",
  path: "votList",
  component: function component() {
    return import('@/views/tms/votManager/votList');
  }
}, {
  name: "vehicleStatusList",
  path: "vehicleStatusList",
  component: function component() {
    return import('@/views/tms/votManager/vehicleStatusList');
  }
}, {
  name: "vehicleLocationList",
  path: "vehicleLocationList",
  component: function component() {
    return import('@/views/tms/votManager/vehicleLocationList');
  }
}, {
  name: "vehicleTrackList",
  path: "vehicleTrackList",
  component: function component() {
    return import('@/views/tms/votManager/vehicleTrackList');
  }
}, {
  path: 'statusDetail',
  name: 'statusDetail',
  component: function component() {
    return import('@/views/tms/votManager/statusDetail.vue');
  }
}, {
  path: 'tmsTrackDetail',
  name: 'tmsTrackDetail',
  component: function component() {
    return import('@/views/tms/votManager/trackDetail.vue');
  }
}];